import SlideFrame from "./_SlideFrame";
import { fmt, PRICING } from "@/lib/api";
import { Sun } from "lucide-react";

const included = [
  "Full compliance team (CCO + analysts)",
  "Compliance management system (CMS)",
  "Policies, procedures & training",
  "Complaint management",
  "Portfolio compliance insights & monitoring",
  "Audit & examination support",
];

export default function SlideCompliSun() {
  return (
    <SlideFrame tag="06 · Compliance">
      <div className="grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-6">
          <p className="overline mb-6 flex items-center gap-3">
            <Sun className="w-4 h-4 text-primary" strokeWidth={1.5} />
            Bundled compliance
          </p>
          <h2 className="font-display text-5xl md:text-6xl tracking-tighter leading-[0.9] font-medium">
            Need a compliance team too? <em className="italic text-primary">Bundle it.</em>
          </h2>
          <p className="mt-8 text-lg text-foreground/75 leading-relaxed max-w-xl">
            Through our CompliSun partnership, IBA Servicing partners can add an <strong>enterprise
            compliance solution</strong> — the entire team, CMS platform, complaint management, and
            live portfolio insights — in one flat monthly fee. Substantially less than building it in-house.
          </p>

          <div className="mt-10 bg-white border-t-4 border-t-primary border-x border-b border-foreground/20 p-8">
            <p className="overline mb-2">Bundled price</p>
            <div className="flex items-baseline gap-4">
              <span className="font-mono-data text-5xl md:text-6xl text-foreground">{fmt(PRICING.compliance_monthly)}</span>
              <span className="text-xs uppercase tracking-brand text-muted-foreground">/month · flat</span>
            </div>
            <p className="mt-3 text-sm text-muted-foreground">
              Available only when combined with IBA Servicing — building an equivalent in-house
              compliance function (CCO + team + CMS + audits) typically runs $60K–$150K per month.
            </p>
          </div>
        </div>

        <div className="lg:col-span-6 lg:pl-10 lg:border-l border-foreground/20">
          <p className="overline mb-6">What&rsquo;s included</p>
          <ul className="border-t border-foreground/20">
            {included.map((it, i) => (
              <li key={i} className="grid grid-cols-12 gap-4 py-4 border-b border-foreground/20 items-baseline">
                <span className="col-span-1 font-mono-data text-xs text-muted-foreground">{String(i + 1).padStart(2, "0")}</span>
                <span className="col-span-11 font-display text-xl">{it}</span>
              </li>
            ))}
          </ul>
          <p className="mt-6 font-mono-data text-xs text-muted-foreground">
            → See savings on the next slide
          </p>
        </div>
      </div>
    </SlideFrame>
  );
}
